<template>
  <div>
    {{ $t('test')}}
  </div>
</template>